import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//在main.js文件中用import导入
//在App.vue中用style的样式下利用@import url()引入
import './assets/css/css.css'
import './assets/css/responsive.css'
import './assets/css/vendor.css'
import './assets/css/style.css'
import './assets/css/style-art.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
